(ns app.survey.event
    (:require
     [ajax.core :as ajax]
     [app.survey.form.sub :as form-sub]
     [app.survey.routes :as routes]
     [app.survey.sub :as sub]
     [cljs-uuid-utils.core :as uuid]
     [common.localization :as loc]
     [frontend.ag-grid :as ag-grid]
     [frontend.logging :as logging]
     [frontend.ui.style.theme.core :as theme]
     [re-frame.core :as rf]
     [ui.components.alert-list.event :as alert-list-event]
     [ui.fx.timeout :as timeout]
     [ui.view.survey.helpers :as survey-helpers]
     [ui.view.survey.sub :as survey-view-sub]))

(rf/reg-event-fx
  ::on-app-config-ok
  (fn [{db :db} [_ re-route? {:keys [body]}]]
    (let [{:keys [tenant survey-access login-email last-sms-sent last-email-sent
                  masked-invited-email masked-phone-number survey accessible-surveys
                  ag-grid-license-key survey-template]}
          body
          process-id (:process-id survey)
          route-to (cond (= :survey.access/many survey-access)
                         :select-survey
                         (= :survey.access/no survey-access)
                         :no-access
                         (= :survey.access/yes survey-access)
                         :loading
                         (= :survey.access/unknown survey-access)
                         :login)]
      (theme/set-theme! (or (:tenant/reporting-theme tenant) :base))
     (ag-grid/init ag-grid-license-key)
      (js/console.log "App config loaded " survey-access " => " route-to "[" re-route? "]")
      (merge {:db (-> db
                      (assoc-in [::sub/survey-access] survey-access)
                      (assoc-in [::sub/tenant] tenant)
                      (assoc-in [::sub/logged-in-email] login-email)
                      (assoc-in [::sub/phone-number] masked-phone-number)
                      (assoc-in [::sub/last-sms-sent] last-sms-sent)
                      (assoc-in [::sub/last-email-sent] last-email-sent)
                      (assoc-in [::sub/auth-type] (:auth-type survey))
                      (assoc-in [::sub/sharing-type] (:sharing-type survey))
                      (assoc-in [::sub/survey-id] process-id)
                      (assoc-in [::sub/survey-template] survey-template)
                      (assoc-in [::sub/invited-email] masked-invited-email)
                      (assoc-in [::sub/accessible-surveys] accessible-surveys))
              :fx (concat (when re-route?
                            [[:dispatch [::routes/navigate [route-to]]]])
                          (when (and re-route?
                                     (= :survey.access/yes survey-access))
                            [[:dispatch [::load-process process-id]]]))}
             (when (= route-to :no-access)
               {::timeout/timeout {:id         (uuid/make-random-uuid)
                                   :event      [::logout]
                                   :wait-ms    5000}})))))

(rf/reg-event-fx
  ::on-app-config-failed
  (fn [{_db :db} [_ resp]]
    (logging/unimplemented "Survey app config failed : " resp)))

(rf/reg-event-fx
  ::load-app-config
  (fn [{_db :db} [_ re-route?]]
    {:http-xhrio {:method          :get
                  :uri             "/surveys/api/app-config"
                  :params          {}
                  :timeout         30000
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-app-config-ok re-route?]
                  :on-failure      [::on-app-config-failed]}}))

(rf/reg-event-fx
  ::on-load-process-ok
  (fn [{db :db} [_ {:keys [body]}]]
    (let [{:keys [survey survey-template
                  survey-answers survey-no-answer-descriptions survey-no-answer-categories
                  previous-answers survey-questions survey-questions-ext-ids survey-files my-file-ids]}
          body
          route-to :form
          v2? (:burned-config survey)
          old-answers (->> survey-answers
                           (map val)
                           (first))
          new-answers (when v2?
                        (let [burned-config (:burned-config survey)
                              questions (survey-helpers/resolve-indexed-questions burned-config)
                              first-question-id (->> questions
                                                     (keep :survey-question-id)
                                                     (first))]
                          (if (seq survey-answers)
                            (->> survey-answers
                                 (map (fn [[idx series-answers]]
                                        [idx (if (seq series-answers)
                                               series-answers
                                               {first-question-id nil})]))
                                 (into {}))
                            {0 {first-question-id nil}})))
          submitted? (some #{(:status survey)} [:survey-process.status/submitted :survey-process.status/approved :survey-process.status/approved-modified])]
      (js/console.log "Loaded process : " survey)
      (js/console.log "prev answers " previous-answers)
      {:db (-> db
               (assoc-in [::survey-view-sub/saved-answer-series (:db/id survey)] new-answers)
               (assoc-in [::survey-view-sub/survey-files (:db/id survey)] survey-files)
               (assoc-in [::survey-view-sub/my-file-ids (:db/id survey)] my-file-ids)
               (assoc-in [::survey-view-sub/survey-processes-last-updated-on (:db/id survey)] (:last-updated-on survey))
               (assoc-in [::survey-view-sub/submitted? (:db/id survey)] submitted?)
               (assoc-in [::survey-view-sub/thank-you-texts (:db/id survey)] (:thank-you-texts survey))
               (assoc-in [::survey-view-sub/survey-questions-ext-ids (:db/id survey)] survey-questions-ext-ids)
               (assoc-in [::form-sub/template] survey-template)
               (assoc-in [::form-sub/survey-process] survey)
               (assoc-in [::form-sub/answers] old-answers)
               (assoc-in [::form-sub/survey-no-answer-categories] survey-no-answer-categories)
               (assoc-in [::form-sub/survey-no-answer-descriptions] survey-no-answer-descriptions)
               (assoc-in [::form-sub/previous-answers] previous-answers)
               (assoc-in [::form-sub/questions] survey-questions))
       :fx (concat [[:dispatch [::routes/navigate [route-to]]]])})))

(rf/reg-event-fx
  ::on-load-process-failed
  (fn [{_db :db} [_ resp]]
    (logging/unimplemented "Survey load process failed : " resp)))

(rf/reg-event-fx
  ::load-process
  (fn [{_db :db} [_ process-id]]
    {:http-xhrio {:method          :post
                  :uri             "/surveys/api/load-process"
                  :params          {:id process-id}
                  :timeout         30000
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-load-process-ok]
                  :on-failure      [::on-load-process-failed]}}))

(rf/reg-event-fx
  ::on-select-survey-ok
  (fn [{db :db} [_ _resp]]
    {:db (-> db
             (assoc-in [::sub/processing?] false))
     :fx [[:dispatch [::load-app-config true]]]}))

(rf/reg-event-fx
  ::on-select-survey-failed
  (fn [{db :db} [_ resp]]
    (logging/unimplemented "Survey app config failed : " resp)
    {:db (-> db
             (assoc-in [::sub/processing?] false))
     :fx [[:dispatch
           [::alert-list-event/add-alert
            {:list-id         :login-notifications
             :hide-in-ms      3000
             :variant         :danger
             :message-content [:div
                               (loc/tr :failed-to-select-survey)]}]]]}))

(rf/reg-event-fx
  ::select-survey
  (fn [{db :db} [_ id]]
    {:db         (-> db
                     (assoc-in [::sub/processing?] true))
     :http-xhrio {:method          :post
                  :uri             "/surveys/api/select-survey"
                  :params          {:survey-id id}
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-select-survey-ok]
                  :on-failure      [::on-select-survey-failed]}}))

(rf/reg-event-fx
  ::on-logout-ok
  (fn [{_db :db} [_ _resp]]
    (set! (.-pathname js/window.location) "/")))

(rf/reg-event-fx
  ::on-logout-failed
  (fn [{db :db} [_ resp]]
    (logging/unimplemented "Survey app config failed : " resp)
    {:db (-> db
             (assoc-in [::sub/processing?] false))
     :fx [[:dispatch
           [::alert-list-event/add-alert
            {:list-id         :login-notifications
             :hide-in-ms      3000
             :variant         :danger
             :message-content [:div
                               (loc/tr :failed-to-logout)]}]]]}))
(rf/reg-event-fx
  ::logout
  (fn [{_db :db} [_ id]]
    {:http-xhrio {:method          :post
                  :uri             "/login/api/logout"
                  :params          {:survey-id id}
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-logout-ok]
                  :on-failure      [::on-logout-failed]}}))
